module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_5.22a77762.png";